import React from "react";
import { Banknote, CreditCard, Landmark, CircleHelp, Wallet } from "lucide-react";

// Metodo di pagamento del CLIENTE (campo booking.payment_method). Nessuna deduzione da altri dati.
export const PAY_GROUPS = {
  cash: { label: "Cash", icon: Banknote, cls: "text-amber-300 border-amber-500/50 bg-amber-500/10" },
  card: { label: "Bancomat/carta", icon: CreditCard, cls: "text-sky-300 border-sky-500/50 bg-sky-500/10" },
  bank: { label: "Bonifico", icon: Landmark, cls: "text-emerald-300 border-emerald-500/50 bg-emerald-500/10" },
  other: { label: "Altro", icon: Wallet, cls: "text-slate-300 border-slate-600 bg-slate-800/40" },
  none: { label: "Non specificato", icon: CircleHelp, cls: "text-slate-500 border-slate-700 bg-transparent" },
};

export function payGroup(method) {
  const m = String(method || "").trim().toLowerCase();
  if (!m) return "none";
  if (/^(contanti|cash|contante)$/.test(m)) return "cash";
  if (/^(pos|carta|bancomat|card|carta di credito|credit card)$/.test(m)) return "card";
  if (/^(bonifico|bank transfer|transfer)$/.test(m)) return "bank";
  return "other";
}

export function PaymentMethodBadge({ method, testid, compact = false }) {
  const g = PAY_GROUPS[payGroup(method)];
  const Icon = g.icon;
  return (
    <span data-testid={testid} title={`Pagamento cliente: ${g.label}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap ${g.cls}`}>
      <Icon size={compact ? 11 : 12} />{compact && g.label === "Bancomat/carta" ? "Carta" : g.label === "Non specificato" && compact ? "N.d." : g.label}
    </span>
  );
}

const FILTERS = [["all", "Tutti", null], ["cash", "Cash", Banknote], ["card", "Bancomat/carta", CreditCard], ["bank", "Bonifico", Landmark], ["other", "Altro", Wallet], ["none", "Non specificato", CircleHelp]];

export function PaymentFilter({ value, onChange, counts }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 no-scrollbar" data-testid="payment-filter">
      {FILTERS.filter(([k]) => k !== "other" || counts.other || value === "other").map(([k, label, Icon]) => {
        const on = value === k;
        const tone = k === "all" ? "" : PAY_GROUPS[k].cls.split(" ")[0];
        return (
          <button key={k} type="button" onClick={() => onChange(k)} data-testid={`payment-filter-${k}`}
            className={`shrink-0 inline-flex items-center gap-1.5 rounded-full border px-3.5 h-9 text-xs font-semibold transition-colors ${on ? "border-amber-400 bg-amber-500/15 text-amber-200 shadow-[0_0_0_1px_rgba(245,158,11,0.35)]" : "border-slate-700 bg-slate-900/50 text-slate-300 hover:border-amber-500/50"}`}>
            {Icon && <Icon size={14} className={on ? "" : tone} />}{label}
            <span className="font-mono-num text-[10px] text-slate-500">{k === "all" ? counts.all : counts[k] || 0}</span>
          </button>
        );
      })}
    </div>
  );
}
